export {default as seq} from "./Sequence";
export {default as seqcol} from "./SeqCollection";
export {default as feature} from "./Feature";
export {default as featurecol} from "./FeatureCol";



// WEBPACK FOOTER //
// ./src/model/index.js